const UNIDADES = [
  '', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve',
  'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete',
  'dieciocho', 'diecinueve', 'veinte', 'veintiuno', 'veintidós', 'veintitrés',
  'veinticuatro', 'veinticinco', 'veintiséis', 'veintisiete', 'veintiocho', 'veintinueve',
];
const DECENAS = ['', '', '', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];
const CENTENAS = ['', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos'];

function dosDigitos(n: number): string {
  if (n < 30) return UNIDADES[n]!;
  const d = Math.floor(n / 10);
  const u = n % 10;
  return u === 0 ? DECENAS[d]! : `${DECENAS[d]} y ${UNIDADES[u]}`;
}

function tresDigitos(n: number): string {
  if (n === 0) return '';
  if (n === 100) return 'cien';
  const c = Math.floor(n / 100);
  const r = n % 100;
  const head = CENTENAS[c]!;
  return r === 0 ? head : `${head} ${dosDigitos(r)}`;
}

/** Apocopate trailing 'uno'/'veintiuno' → 'un'/'veintiún' before a masculine noun / 'mil' / 'millón'. */
function apocopar(s: string): string {
  return s.replace(/veintiuno$/, 'veintiún').replace(/uno$/, 'un');
}

function enteroEnLetras(n: number): string {
  if (n === 0) return 'cero';
  const millones = Math.floor(n / 1_000_000);
  const miles = Math.floor((n % 1_000_000) / 1000);
  const resto = n % 1000;
  const parts: string[] = [];
  if (millones === 1) parts.push('un millón');
  else if (millones > 1) parts.push(`${apocopar(tresDigitos(millones))} millones`);
  if (miles === 1) parts.push('mil');
  else if (miles > 1) parts.push(`${apocopar(tresDigitos(miles))} mil`);
  if (resto > 0) parts.push(tresDigitos(resto));
  return parts.join(' ').trim();
}

/** Spanish words for a GTQ amount, e.g. '8000' → 'Ocho mil quetzales exactos'. Range 0..9,999,999.99. */
export function montoEnLetras(amount: string | number): string {
  const num = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(num) || num < 0) throw new Error('montoEnLetras: monto inválido');
  const cents = Math.round(num * 100);
  const entero = Math.floor(cents / 100);
  const centavos = cents % 100;
  const palabras = apocopar(enteroEnLetras(entero));
  const noun = entero === 1 ? 'quetzal' : 'quetzales';
  // "un millón de quetzales" / "dos millones de quetzales": 'de' only when the amount is a whole
  // number of millones, so the noun directly follows millón/millones.
  const de = entero >= 1_000_000 && entero % 1_000_000 === 0 ? 'de ' : '';
  const suffix = centavos === 0
    ? entero === 1 ? 'exacto' : 'exactos'
    : `con ${String(centavos).padStart(2, '0')}/100`;
  const cuerpo = `${palabras} ${de}${noun} ${suffix}`.replace(/\s+/g, ' ').trim();
  return cuerpo.charAt(0).toUpperCase() + cuerpo.slice(1);
}

const ORDINALES = [
  '', 'Primer', 'Segundo', 'Tercer', 'Cuarto', 'Quinto', 'Sexto', 'Séptimo', 'Octavo', 'Noveno',
  'Décimo', 'Undécimo', 'Duodécimo', 'Decimotercer', 'Decimocuarto', 'Decimoquinto',
  'Decimosexto', 'Decimoséptimo', 'Decimoctavo', 'Decimonoveno', 'Vigésimo',
];

/** Default receipt concept, e.g. 'Sexto pago de lote 16 letra E'. Numeric fallback beyond 20. */
export function conceptoDefault(input: { cuotaNumber: number; lotNumber?: string | null; manzana?: string | null }): string {
  const { cuotaNumber, lotNumber, manzana } = input;
  const lote = lotNumber ? ` de lote ${lotNumber}${manzana ? ` letra ${manzana}` : ''}` : '';
  const head = cuotaNumber >= 1 && cuotaNumber <= 20 ? `${ORDINALES[cuotaNumber]} pago` : `Pago No. ${cuotaNumber}`;
  return `${head}${lote}`.trim();
}
